export default "__VITE_PUBLIC_ASSET__d919d8bd__"